import { render, staticRenderFns } from "./main.saldosInventario.vue?vue&type=template&id=074dbe7b"
import script from "./main.saldosInventario.vue?vue&type=script&lang=js"
export * from "./main.saldosInventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports